import Controller from "./home.controller";
import template from "./home.html";

const home = {
  template,
  controller: Controller,
};

export default home;



// WEBPACK FOOTER //
// ./src/pages/home/home.component.js